module.exports = __webpack_public_path__ + "img/photo-1600783246032-1056431c253c.32b56520.jpeg";